{
  "title": "Endre salgsavtale",
  "breadcrumb": "Endre salgsavtale",
  "agreementInformation": {
    "section": {
      "title": "Om salgsavtalen",
      "description": "Rediger informasjon om salgsavtalen"
    },
    "date": {
      "label": "Dato for salgsavtale",
      "description": "Velg start og sluttdato for salgsavtalen",
      "placeholder": "Velg datoer"
    },
    "dateTo": {
      "label": "Sluttdato for salgsavtale",
      "description": "Velg sluttdato for salgsavtalen",
      "placeholder": "Velg dato"
    },
    "name": {
      "label": "Navn på salgsavtale",
      "description": "Gi avtalen et navn"
    },
    "responsibleEmployee": {
      "label": "Ansvarlig ansatt",
      "description": "Velg ansatt som har ansvaret for salgsavtalen",
      "placeholder": "Velg ansatt",
      "noResultsText": "Ingen ansatte funnet"
    },
    "issuer": {
      "label": "Utsteder av mål- og transportoppdrag",
      "description": "Velg mellom selger, kjøper eller ingen",
      "placeholder": "Velg utsteder",
      "options": {
        "none": "Ingen",
        "seller": "Selger",
        "buyer": "Kjøper"
      }
    },
    "orderNumber": {
      "label": "Varemottaker bestillingsnummer (8 siffer)",
      "description": "Eksempel: 12345678"
    },
    "commission": {
      "label": "Provisjon",
      "description": "Oppgis mellom 0-100%. Eksempel: 12,50"
    },
    "certificationType": {
      "label": "Sertifiseringstype",
      "description": "Velg hvilken type sertifisering som skal brukes",
      "placeholder": "Velg sertifiseringstype",
      "options": {
        "none": "Ikke angitt",
        "pefc": "PEFC",
        "fsc": "FSC",
        "pefcAndFsc": "PEFC / FSC",
        "other": "Annet"
      }
    },
    "certificateText": {
      "label": "Sertifikattekst på dokumenter",
      "placeholder": ""
    },
    "measurementCostsNotRefunded": {
      "label": "Målekostnader skal ikke refunderes"
    }
  },
  "transportInformation": {
    "section": {
      "title": "Transportinformasjon",
      "description": "Fyll inn nødvendig informasjon om transportør"
    },
    "transportResponsible": {
      "label": "Transportansvarlig",
      "description": "Velg hvem som administrerer transport av virke",
      "noResultsText": "Ingen transportansvarlige funnet"
    },
    "transportPayer": {
      "label": "Transportbruker",
      "description": "Velg hvem som er ansvarlig for transportkostnaden",
      "noResultsText": "Ingen transportbrukere funnet"
    },
    "measurementOrganization": {
      "label": "Måleorganisasjon",
      "description": "Velg hvem som er ansvarlig for måling av virke",
      "noResultsText": "Ingen måleorganisasjoner funnet"
    },
    "deliveryLocations": {
      "label": "Mottakssteder",
      "description": "Velg ett eller flere mottakssteder",
      "noResultsText": "Ingen mottakssteder funnet"
    }
  },
  "navigation": {
    "backToOverview": "Tilbake til oversikt",
    "backToSalesAgreement": "Tilbake til salgsavtale",
    "cancel": "Avbryt",
    "save": "Lagre endringer"
  },
  "toast": {
    "error": {
      "title": "Kunne ikke lagre salgsavtale",
      "description": "Noe gikk galt under lagringen av salgsavtalen. Prøv igjen."
    }
  },
  "cancelDialog": {
    "title": "Vil du avbryte redigeringen?",
    "description": "Alle endringer du har gjort vil gå tapt.",
    "confirmCancel": "Avbryt uten å lagre",
    "continueEditing": "Fortsett redigering"
  },
  "error": {
    "title": "Kunne ikke laste inn redigeringsskjemaet",
    "description": "Noe gikk galt under henting av salgsavtaleinformasjon. Prøv igjen.",
    "retry": "Prøv igjen",
    "goToOverview": "Tilbake til oversikt"
  }
}
